import {Collapse} from 'bootstrap';

// Mobile menu = Bootstrap offcanvas (#navBar), a panel directly under the bar: backdrop, scroll lock, Escape and focus
// come from Bootstrap. This adds: html.nav-open while it is open (hides the color switch at the page edge, see
// _header.scss), --nav-panel-top (the lower edge of the bar, where panel and backdrop start), the state of the menu
// button of the bar (it turns into the cross, Bootstrap does not manage that for offcanvas) and the search field of
// the menu (opened by the magnifier): focus into the field, closed again with the menu.
export default function initMobileNav() {
    const nav = document.getElementById('navBar');
    const panel = document.getElementById('navSearchPanel');
    const root = document.documentElement;
    const header = document.querySelector('header');
    const togglers = document.querySelectorAll('[data-bs-target="#navBar"].navbar-toggler');

    const placePanel = () => {
        if (header) {
            root.style.setProperty('--nav-panel-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
        }
    };
    const markToggler = (open) => togglers.forEach((button) => {
        button.classList.toggle('collapsed', !open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (nav) {
        nav.addEventListener('show.bs.offcanvas', () => {
            placePanel();
            root.classList.add('nav-open');
            markToggler(true);
        });
        nav.addEventListener('shown.bs.offcanvas', placePanel);
        nav.addEventListener('hide.bs.offcanvas', () => markToggler(false));
        window.addEventListener('resize', () => nav.classList.contains('show') && placePanel());
        nav.addEventListener('hidden.bs.offcanvas', () => {
            root.classList.remove('nav-open');
            if (panel && panel.classList.contains('show')) {
                Collapse.getOrCreateInstance(panel, {toggle: false}).hide();
            }
        });
    }

    if (panel) {
        panel.addEventListener('shown.bs.collapse', () => {
            const field = panel.querySelector('input[type="text"], input[type="search"]');
            if (field) {
                field.focus();
            }
        });
    }
}
